import { Outlet, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "../Navbar/Navbar";
import ScrollToTop from "../ScrollToTop";

const footerLinks = [
  { label: "Employers",  to: "/employers"  },
  { label: "Candidates", to: "/candidates" },
  { label: "About",      to: "/about"      },
  { label: "Our Team",   to: "/team"       },
  { label: "Contact",    to: "/contact"    },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <ScrollToTop />
      <main className="flex-1">
        <AnimatePresence mode="wait">
          <Outlet key={location.pathname} />
        </AnimatePresence>
      </main>

      {/* Footer */}
      <footer className="border-t mt-auto" style={{ borderColor: "rgba(226,232,240,0.5)" }}>
        <div className="containerX py-8">
          <div className="grid md:grid-cols-3 gap-6">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2">
                <img src="/logo.jpeg" alt="hirrd" className="h-8 w-8 rounded-lg object-cover" />
                <div className="font-semibold text-slate-900">hirrd</div>
              </div>
              <p className="text-sm text-slate-500 mt-2 max-w-xs">
                Not just recruiting. We're building a network where engineers thrive and startups find the right talent.
              </p>
            </div>

            {/* Links */}
            <div>
              <div className="text-sm font-semibold text-slate-700 mb-2">Navigation</div>
              <div className="grid gap-1">
                {footerLinks.map((l) => (
                  <NavLink key={l.to} to={l.to} className="text-sm text-slate-500 hover:text-violet-600 transition">
                    {l.label}
                  </NavLink>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <div className="text-sm font-semibold text-slate-700 mb-2">Get in touch</div>
              <div className="grid gap-1 text-sm text-slate-500">
                <a href="mailto:contact@hirrd.com" className="hover:text-violet-600 transition">contact@hirrd.com</a>
                <a href="tel:+12072508698" className="hover:text-violet-600 transition">+1 207 250 8698</a>
              </div>
            </div>
          </div>

          <div className="border-t mt-6 pt-4 text-xs text-slate-400" style={{ borderColor: "rgba(226,232,240,0.5)" }}>
            © {new Date().getFullYear()} hirrd. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
